export var RESET_CURRENT_IMAGE = 'RESET_CURRENT_IMAGE';
export var SET_CURRENT_IMAGE = 'SET_CURRENT_IMAGE';
export var SET_PRODUCT_NAV = 'SET_PRODUCT_NAV';
export var SET_PRODUCT = 'SET_PRODUCT';
export var SET_PRODUCT_CAROUSELS = 'SET_PRODUCT_CAROUSELS';
export var SET_PRODUCT_IMAGES = 'SET_PRODUCT_IMAGES';
export var SET_RR_PRODUCT = 'SET_RR_PRODUCT';
export var RESET_PRODUCT = 'RESET_PRODUCT';